import React from "react"
import AdfoxAdaptive from "./AdFoxAdaptive"


export function AdfoxSticky({isFull, isDesktop, options, className = "adfox"}) {
    if (!options) {
        return null
    }

    const option = isFull ? (isDesktop ? options.fullPc : options.fullMob) : (isDesktop ? options.prevPc : options.prevMob)

    if (!option) {
        return null;
    }

    return isDesktop ? (
        <AdfoxAdaptive options={option} className={className}/>
    ) : (
        <div style={{height: "600px"}}>
            <div className="sticky-block">
                <div className="sticky-block-content">
                    <AdfoxAdaptive options={option} className={className}/>
                </div>
            </div>
        </div>
    )
}
